module.exports = __webpack_public_path__ + "a291bbb1908e88e3038fab1ef45d0460.svg";